module.exports = __webpack_public_path__ + "img/1.4119a026.png";